<!-- 溯源码订单 -->
<template>
    <div>
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入用户名称、手机号"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.version_id"
                clearable
                filterable
                placeholder="请选择版本"
            >
                <Option
                    v-for="item in versionList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.status"
                placeholder="请选择支付状态"
            >
                <Option
                    v-for="item in statusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24"
                icon="ios-search"
                type="warning"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="goModal"
                >增加</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="user">
                    <div>{{ row.admin ? row.admin.user : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="phone">
                    <div>{{ row.admin ? row.admin.phone : "" }}</div>
                </template>
                <template
                    v-if="row.status == 1 && row.pay_type != 3"
                    slot-scope="{ row }"
                    slot="operate"
                >
                    <Button
                        type="error"
                        ghost
                        label="small"
                        @click="goRefund(row)"
                        >退款</Button
                    >
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <!-- 增加 -->
        <Modal
            v-model="add_modal"
            title="增加"
            width="500"
            :mask-closable="false"
        >
            <Form :model="form_item" label-position="right" :label-width="100">
                <FormItem label="选择用户：">
                    <Select
                        class="w300"
                        v-model="form_item.user_id"
                        clearable
                        filterable
                        placeholder="请选择用户"
                    >
                        <Option
                            v-for="item in accountList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.user }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="选择版本：">
                    <Select
                        class="w300"
                        v-model="form_item.version_id"
                        clearable
                        filterable
                        placeholder="请选择版本"
                    >
                        <Option
                            v-for="item in versionList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="金额：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="form_item.price"
                        placeholder="请输入金额"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <!-- 退款 -->
        <Modal
            v-model="refund_modal"
            title="退款"
            width="600"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="form_data"
                    label-position="right"
                    :label-width="140"
                >
                    <FormItem label="退款原因：">
                        <Input
                            class="w300"
                            type="textarea"
                            v-model="form_data.reason"
                            placeholder="请输入退款原因"
                        ></Input>
                    </FormItem>
                    <FormItem label="退款金额：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_data.refund_money"
                            placeholder="请输入退款金额"
                            ><span slot="append">元</span></Input
                        >
                    </FormItem>
                    <FormItem label="删除对应套餐：">
                        <RadioGroup v-model="form_data.remove_app">
                            <Radio label="0" class="mr48">否</Radio>
                            <Radio label="1">是</Radio>
                        </RadioGroup>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelRefundModal">取消</Button>
                <Button
                    :disabled="isSubmitting"
                    class="theme-bc"
                    type="warning"
                    @click="submitRefundModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    plat_order_version,
    account_select,
    version_qrcode_select,
    order_qrcode_buy,
    order_refund,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                keywords: "",
                type: 2,
                version_id: -1,
                status: -1,
            },
            total: 0,
            versionList: [],
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "用户名称", slot: "user", align: "center" },
                { title: "手机号", slot: "phone", align: "center" },
                { title: "版本", key: "name", align: "center" },
                { title: "订单金额", key: "price", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "购买方式", key: "pay_type_text", align: "center" },
                { title: "付款状态", key: "status_text", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "100px",
                },
            ],
            dataTable: [],
            accountList: [],
            add_modal: false,
            form_item: {
                user_id: "",
                version_id: "",
                price: "",
            },
            statusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "未支付" },
                { id: 1, name: "支付成功" },
            ],
            refund_modal: false,
            form_data: {
                id: "",
                reason: "",
                refund_money: "",
                remove_app: "0",
            },
            isSubmitting: false,
        };
    },
    mounted() {
        this.getList();
        this.getVersionSelect();
        this.getAccountSelect();
    },
    methods: {
        getAccountSelect() {
            account_select().then((res) => {
                this.accountList = res.data;
            });
        },
        getVersionSelect() {
            version_qrcode_select().then((res) => {
                this.versionList = res.data;
            });
        },
        getList() {
            plat_order_version(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        goModal() {
            this.form_item.user_id = "";
            this.form_item.version_id = "";
            this.form_item.price = "";
            this.add_modal = true;
        },
        // 确定
        submitModal() {
            order_qrcode_buy(this.form_item)
                .then((res) => {
                    this.getList();
                    this.add_modal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.add_modal = false;
        },
        goRefund(row) {
            this.form_data.id = row.id;
            this.form_data.reason = "";
            this.form_data.refund_money = row.price;
            this.form_data.remove_app = "0";
            this.refund_modal = true;
        },
        // 确定
        submitRefundModal() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            order_refund(this.form_data)
                .then((res) => {
                    this.getList();
                    this.refund_modal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },
        cancelRefundModal() {
            this.refund_modal = false;
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.text-align-right {
    text-align: right;
}
.mr48 {
    margin-right: 48px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner {
    border-color: #ff761d;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner:after {
    background-color: #ff761d;
}
</style>